import React, { useState, useEffect } from "react";
import { Button, Row, Modal } from "react-bootstrap";
import { CForm, CCol, CFormLabel, CFormFeedback, CFormInput, CButton } from "@coreui/react";
import { useDispatch } from "react-redux";
import { ToastContainer } from "react-toastify";
import { toastMessage } from "../../../helpers/utility.js";
import { getData, modifyData } from "../../../redux/slices/MasterPaymentModeSlice";
// import DeleteConfirmationModal from "../../../pagecomponents/Common/DeleteConfirmationModal";
import PageWrapper from "../../../pagecomponents/Common/PageWrapper";
import DataTable from "../../../pagecomponents/Common/DataTable";
import Swal from "sweetalert2";
import { getBasicdata } from "../../../redux/slices/BasicDataSlice.js";
import { deleteMasterData } from "../../../redux/api-calls/deleteMasterData.js";
import { MASTER_DATA_TYPE } from "../utils/constnsts.js";

const INIT_FORM_DATA = { payment_mode_master_Id: 0, payment_mode_Name: "", payment_mode_Code: "", type: "", client_Id: 1 };

const PaymentModeIndex = () => {
    const dispatch = useDispatch();
    const pageName = "Payment Mode";
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [totalPage, setTotalPage] = useState(0);

    const PARAMS = {
        skip: 0,
        take: rowsPerPage,
        type: "payment_mode",
        sorting: 'asc',
        sorting_key: 'created_at',
        filter: {
            
        }
    };

    const [data, setData] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    // const [deleteAlertVisible, setDeleteAlertVisible] = useState(false);
    const [validated, setValidated] = useState(false);
    const [params, setParams] = useState(PARAMS);
    const [formData, setFormData] = useState(INIT_FORM_DATA);
    const [isEdit, setIsEdit] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSaveDisabled, setIsSaveDisabled] = useState(false);
    
    useEffect(() => {
        fetchMasterData();
    }, [params]);

    useEffect(() => {
        fetchBasicData();
    }, []);
    const fetchBasicData = async () => {
        console.log("fetchBasicData called..");
        
        try {
            const { payload } = await dispatch(getBasicdata({}));
            console.log("Payload from API:", payload);

            if (payload && payload.client_Id) {
                setFormData((prevFormData) => ({
                    ...prevFormData,
                    client_Id: payload.client_Id,
                }));
                console.log("Updated formData:", formData);
            } else {
                toastMessage("error", "client_Id is missing in the response");
            }
            
        } catch (err) {
            toastMessage("error", "Failed to fetch basic data");
        } finally {
        }
    };

    // API calls

    const fetchMasterData = async () => {
        setIsLoading(true);
                
        try {
            const { payload } = await dispatch(getData({ inputData: params }));
            setData(payload.payment_mode);
            setTotalPage(Math.ceil(payload.payment_mode_count/rowsPerPage));
        } catch (err) {
            toastMessage("error", "Failed to fetch data");
        } finally {
            setIsLoading(false); // Stop loader
        }
    };
    
    const handleSave = async (formData) => {
        setIsSaveDisabled(true);
        const { payload } = await dispatch(modifyData({ inputData: formData }));
        if (payload?.status === "error") {
            setIsSaveDisabled(false);
            toastMessage("error", payload.msg || "An error occurred while saving.");
        } else {

            if(formData.type === 'delete') {
                setIsSaveDisabled(false);
                // setDeleteAlertVisible(false);
                Swal.fire("Deleted!", "Your file has been deleted.", "success");
            } else {
                setIsSaveDisabled(false);
                toastMessage(payload?.status || "success", payload?.msg || "Operation successful.");
                closeModal();
            }

            fetchMasterData();
        }
    };

    // Event handlers

    const handleInputChange = (e) => {
        const {name, value} = e.target;
                        
        setFormData({...formData, [name] : value});
    };

    const openAddModal = () => {
        setIsEdit(false);
        // setIsDelete(false);
        setFormData(INIT_FORM_DATA);
        setModalVisible(true);
    };

    const openEditModal = (item) => {
        setIsEdit(true);
        // setIsDelete(false);
        setFormData({ ...item, payment_mode_Code: item.payment_mode_Code || "", type: item.type || "" });
        setModalVisible(true);
    };

    const handleDelete = async (item) => {
        const data = await deleteMasterData({type: MASTER_DATA_TYPE.PAYMENT_MODE, id: item.payment_mode_master_Id})
        if(data.error || data.status === "error") {
           toastMessage("error",data.msg ?? data.error ?? "An error occurred while saving.");
        }
        fetchMasterData();
    };

    const closeModal = () => {
        setModalVisible(false);
        setValidated(false);
        setFormData(INIT_FORM_DATA);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        } else {
            handleSave(formData);
        }
        setValidated(true);
    };


    const handleSort = (key) => {
        setCurrentPage(1);
        
        setParams((prev) => ({
            ...prev,
            skip: 0,
            sorting_key: key,
            sorting: prev.sorting_key === key && prev.sorting === "asc" ? "desc" : "asc",
        }));
    };

    const handleRowsPerPageChange = (rows) => {
        setRowsPerPage(rows);
        setCurrentPage(1);
        
        setParams((prev) => ({
          ...prev,
          take: rows,
          skip: 0,
        }));
    };

    const setPage = (pagenum) => {
        setCurrentPage(pagenum);
        setParams((prev) => ({
            ...prev,
            skip: (pagenum - 1) * prev.take,
        }));
    };

    const columns = [
        {label: "#", accessor: "index", sortable: false},
        {label: "Name", accessor: "payment_mode_Name", sortable: true},
    ];
    
    // UI

    return(
        <>
            <ToastContainer />
            <PageWrapper 
                pageName={pageName}
                headerBtnTitle={"+ " + pageName}
                onHeaderButtonClick={() => {openAddModal()}}
                showAddBtn={true}
            >
                <DataTable 
                    pageName={pageName}
                    columns={columns} 
                    data={data} 
                    onEdit={openEditModal}
                    onDelete={handleDelete}
                    deleteEnabled
                    onSorting={handleSort}
                    sortingState={{ key: params.sorting_key, order: params.sorting }}
                    currentPage={currentPage}
                    totalPages={totalPage}
                    rowsPerPage={rowsPerPage}
                    updateRowsPerPage={handleRowsPerPageChange}
                    onPageChange={setPage}
                    loader={isLoading}
                />
            </PageWrapper>

            {/* Add/Edit Modal */}
            <Modal show={modalVisible} onHide={closeModal}>
                <Modal.Header className="bg-dark text-white">
                    <Modal.Title>{isEdit ? "Edit Payment Mode" : "Add Payment Mode"}</Modal.Title>
                    <Button variant="" className="btn btn-close text-white" onClick={closeModal}>x</Button>
                </Modal.Header>
                <Modal.Body>
                    <CForm
                    className="g-3 needs-validation"
                    noValidate
                    validated={validated}
                    onSubmit={handleSubmit}
                    >
                        <Row className="row-xs mb-2">
                            <CCol md={12}>
                                <CFormLabel className="main-content-label tx-11 tx-medium tx-gray-600" htmlFor="payment_mode_Name">Payment Mode Name</CFormLabel>
                                <CFormInput
                                    type="text"
                                    id="payment_mode_Name"
                                    name="payment_mode_Name"
                                    value={formData.payment_mode_Name}
                                    onChange={handleInputChange}
                                    required
                                    // pattern="^[a-zA-Z\s]+$" // Ensures no special characters
                                />
                                <CFormFeedback invalid>Enter Payment Mode Name</CFormFeedback>
                            </CCol>
                        </Row>
                        <Row className="row-xs mb-2 btn-animation">
                            <CCol xs={12} className="mt-10">
                                {/* <CButton color="primary" className="btn btn-sm float-end" type="submit">Save Changes</CButton>
                                <CButton color="secondary" className="btn btn-sm float-end me-2" onClick={closeModal}>Close</CButton> */}

                                <CButton
                                    color="primary" 
                                    className={`btn btn-sm float-end ${isSaveDisabled ? 'btn-loaders' : ''}`} 
                                    type="submit"
                                    disabled={isSaveDisabled}
                                >
                                    {isSaveDisabled ? (<span className="loading">Save Changes</span>) : "Save Changes"}
                                </CButton>
                                <CButton color="secondary" className="btn btn-sm float-end me-2" onClick={closeModal} disabled={isSaveDisabled}>
                                    Close
                                </CButton>
                            </CCol>
                        </Row>
                    </CForm>
                </Modal.Body>
            </Modal>

            {/* <DeleteConfirmationModal 
                show={deleteAlertVisible}
                onHide={() => setDeleteAlertVisible(false)}
                onConfirm={handleSave}
                message={'Are you sure you want to delete this record? This action is irreversible.'}
            /> */}
        </>
    );
};

export default PaymentModeIndex;